import CreateCustomDomainListModal from "./CreateCustomDomainListModal";

export default CreateCustomDomainListModal;
